<template>
  <ais-toggle-refinement
    :attribute="attribute"
    :label="label"
  >
    <div
      slot-scope="{ value, refine }"
      @click.prevent="refine(value)"
      class="flex items-center h-full ml-4 cursor-pointer"
    >
      <div class="border border-honestly-white w-4 h-4 flex items-center justify-center">
        <i v-if="value.isRefined" class="fa fa-check text-xs"></i>
      </div>
      <div class="ml-2">{{ label }}</div>
    </div>
  </ais-toggle-refinement>
</template>

<script>
export default {
  props: {
    attribute: String,
    label: String,
  },
};
</script>

<style scoped>
</style>
